<template>
  <div class="clearfix "><div class="table-top"><i class="fa  fa-edit"></i><span v-html="tableTop"></span></div></div>
</template>
<script>
  export default {
    props: ['tableTop']
  }
</script>
<style lang="less" scoped>
  .table-top{    
    text-align: center;   
    border-bottom:none; 
    // border-top: 2px solid #1C86EE;
    font-size:16px;
    float:left;
    padding:8px 0;
    width:100%;
    
    i{
      margin-right: 10px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/TableTop/index.vue